<template>
  <section>
    <b-tabs>
      <b-tab title="Summary">
        <summary-tab :serviceOrderLine="serviceOrderLine" :serviceOrder="serviceOrder" @on-refresh="$emit('on-refresh')" @credit-applied="$emit('credit-applied')"  />
      </b-tab>
      <b-tab v-if="checkClaim(CAN_VIEW_INVENTORY)">
          <template v-slot:title>
            PO Received Items &nbsp;<b-badge variant="primary">{{ inventoryListFiltered.length }}</b-badge>
          </template>
        <inventory-list :gridId="inventoryGridId" :purchaseOrderLineId="serviceOrderLine.purchaseOrderLineId"/>
      </b-tab>
      <b-tab v-if="checkClaim(CAN_VIEW_INVENTORY)">
        <template v-slot:title>
          Pick Tickets <b-badge variant="primary">{{ pickTicketLinesByServiceOrderLine.length }}</b-badge>
        </template>
        <pick-ticket-lines-tab :serviceOrderLineId="serviceOrderLine.id" isWOTab />
      </b-tab>
      <b-tab v-if="checkClaim(CAN_VIEW_ALL_POS)">
        <template v-slot:title>
          Purchase Orders &nbsp;<b-badge variant="primary">{{ purchaseOrderLines.length }}</b-badge>
        </template>
        <on-orders :purchaseOrderLineId="serviceOrderLine.purchaseOrderLineId" :gridId="purchaseOrderGridId" isPOTab />
      </b-tab>
      <b-tab>
        <template v-slot:title>
          Sales Orders &nbsp;<b-badge variant="primary">{{ salesOrdersCustom.length }}</b-badge>
        </template>
        <sales-orders :dataBy="'salesOrder'" :salesOrderLineId="serviceOrderLine.salesOrderLineId" :gridId="soLineGridId" />
      </b-tab>
<!--      <b-tab title="Invoices" v-if="checkClaim(CAN_VIEW_ALL_INVOICES)">-->
<!--        <invoices-list :serviceOrderLine="serviceOrderLine.id" :gridId="invoiceGridId"/>-->
<!--      </b-tab>-->
      <b-tab title="Documents and Images">
        <documents-and-images :reference="'serviceOrderLineId'" :refId="serviceOrderLine.id" :partId="serviceOrderLine.partId" />
      </b-tab>
    </b-tabs>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { GRID_ID } from '@/shared/constants';
  import SummaryTab from './Summary';
  import InventoryList from '@/shared/components/InventoryList';
  import InvoicesList from '@/shared/components/InvoiceLines';
  import OnOrders from '@/shared/components/OnOrder';
  import SalesOrders from '@/shared/components/SalesOrders';
  import DocumentsAndImages from '@/shared/components/DocumentsAndImages';
  import PickTicketLinesTab from '@/shared/components/PickList/components/PickTicketLines';

  export default {
    components: {
      SummaryTab,
      InventoryList,
      InvoicesList,
      OnOrders,
      SalesOrders,
      DocumentsAndImages,
      PickTicketLinesTab
    },
    props: {
      // serviceOrderLine: {
      //   type: Object,
      //   default: () => {
      //   },
      // },
      serviceOrder: {
        type: Object,
        default: () => {},
      },
      purchaseOrderLineId: {
        type: [Number, String],
        default:0
      }
    },
    computed: {
      ...mapGetters('inventory', [ 'inventoryListFiltered' ]),
      ...mapGetters('salesOrders', ['salesOrdersCustom']),
      ...mapGetters('purchaseorders', [ 'purchaseOrderLines' ]),
      ...mapGetters('pickTicket', ['pickTicketLinesByServiceOrderLine']),
      ...mapGetters('serviceOrderLines', ['serviceOrderLine']),
    },
    data() {
      return {
        inventoryGridId: GRID_ID.INVENTORY_SERVICE_ORDERS_GRID,
        purchaseOrderGridId: GRID_ID.PURCHASE_ORDERS_SERVICE_ORDER_GRID,
        invoiceGridId: GRID_ID.INVOICES_SERVICE_ORDERS_GRID,
        soLineGridId: GRID_ID.SALES_ORDER_LINES_TAB_GRID,
      };
    },
    mounted() {
      //console.log(this.serviceOrderLine,this.serviceorder);
    }
  };
</script>
